<template>
    <div :style="{'--animate-duration': animationDuration + 'ms'}">
        <transition
            appear
            :enter-active-class="enterActiveClass"
            :leave-active-class="leaveActiveClass" mode="out-in" :duration="animationDuration/2">
            <div :key="steps[currentStep].id" v-if="steps.length > currentStep">
                <slot :name="steps[currentStep].id" v-bind:step="steps[currentStep]" />
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'zoezi-stepper-content',

    zoezi: {
        title: 'Stepper - content',
        internal: true
    },

    props: {
        value: {
            type: Number
        },
        steps: {
            type: Array
        },
        animationDuration: {
            type: Number,
            default: 700
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.setStep(this.currentStep, value);
            }
        }
    },
    data: () => ({
        currentStep: 0,
        animationForwardDirection: true
    }),
    computed: {
        enterActiveClass() {
            return 'animate__animated animate__bounceIn' + (this.animationForwardDirection ? 'Right' : 'Left')
        },
        leaveActiveClass() {
            return 'animate__animated animate__bounceOut' + (this.animationForwardDirection ? 'Left' : 'Right')
        }
    },
    methods: {
        getScrollParent(node) {
            if (node == null) {
                return null;
            }

            if (node.scrollHeight > node.clientHeight) {
                return node;
            } else {
                return this.getScrollParent(node.parentNode);
            }
        },
        setStep(from, to) {
            this.animationForwardDirection = to >= from;
            this.currentStep = to;

            if (this.$el) {
                let scrollParent = this.getScrollParent(this.$el)
                if (scrollParent) {
                    scrollParent.scroll({top: 0, behavior: 'smooth'});
                }
            }
        }
    }
}
</script>
